import DigiobcanApi, { type Issue } from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
  category?: string[];
  status?: Issue['status'][];
};

export const getVotings = createQueryFn(
  QueryNameSpace.getVotings,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], string[]>) => {
    const [, params] = queryKey;

    const data = await DigiobcanApi.getVotings({
      ...params,
      pagecursor: pageParam,
    });

    return data.votings;
  },
);
